import {Injectable, EventEmitter} from "@angular/core";

/**
 * Created by akifh on 04/03/2018.
 */
@Injectable({ providedIn: "root"})
export class KlaEmitterService {

  public static search: EventEmitter<string> = new EventEmitter<string>();

  public emitSearch(value: string) {
    KlaEmitterService.search.emit(value);
  }

  public subscribeSearch(generatorOrNext?: any, error?: any, complete?: any) {
    KlaEmitterService.search.subscribe(generatorOrNext, error, complete);
  }
}
